import { render, staticRenderFns } from "./socketRecord.vue?vue&type=template&id=566ed863&scoped=true"
import script from "./socketRecord.vue?vue&type=script&lang=js"
export * from "./socketRecord.vue?vue&type=script&lang=js"
import style0 from "./socketRecord.vue?vue&type=style&index=0&id=566ed863&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566ed863",
  null
  
)

export default component.exports